/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2021-2023 OKTET Labs Ltd. */
import { BUBLIK_TAG } from './types';

export const tagTypes: BUBLIK_TAG[] = [
	BUBLIK_TAG.DashboardData,
	BUBLIK_TAG.DeployInfo,
	BUBLIK_TAG.HistoryData,
	BUBLIK_TAG.LogData,
	BUBLIK_TAG.User,
	BUBLIK_TAG.Analytics
];
